import React from "react"

import TopWhiteSwirl from "../assets/SVG/WhiteSwirlTop.svg";
import TopDarkSwirl from "../assets/SVG/DarkSwirlTop.svg";
import BottomDarkSwirl from "../assets/SVG/DarkSwirlBottom.svg";
import BottomWhiteSwirl from "../assets/SVG/WhiteSwirlBottom.svg";
import "../scss/components/swirl-component.scss" 


const SwirlComponent = ({ bgColor, topSwirl, overlaySwirl }) => {
    const overlaySwirlClass = overlaySwirl == true ? "overlay-swirl" : '';
    
    // const topWhiteSwirlStyle = {
    //     backgroundImage: `url(${TopWhiteSwirl})`,
    //     backgroundSize: "cover",
    //     backgroundRepeat: "no-repeat",
    //     backgroundPosition: "top center",
    //     width: "100%",
    //     minHeight: "210px",
    //     position: overlaySwirl == true ?  "absolute" : "relative",
    //     //top: overlayTop,
        
    //   };
    //   const topDarkSwirlStyle = {
    //     backgroundImage: `url(${TopDarkSwirl})`,
    //     backgroundSize: "cover",
    //     backgroundRepeat: "no-repeat",
    //     backgroundPosition: "top center",
    //     width: "100%",
    //     minHeight: "210px",
    //     position: overlaySwirl == true ?  "absolute" : "relative",
    //     //top: overlayTop,
    //   };
    //   const bottomDarkSwirlStyle = {
    //     backgroundImage: `url(${BottomDarkSwirl})`,
    //     backgroundSize: "cover",
    //     backgroundRepeat: "no-repeat",
    //     backgroundPosition: "top center",
    //     width: "100%",
    //     minHeight: "210px",
    //   };
    //   const bottomWhiteSwirlStyle = {
    //     backgroundImage: `url(${BottomWhiteSwirl})`,
    //     backgroundSize: "cover",
    //     backgroundRepeat: "no-repeat",
    //     backgroundPosition: "top center",
    //     width: "100%",
    //     minHeight: "210px",
    //   };

      // if(topSwirl == true){
      //   return(
      //       (bgColor == "White") ? <div className={`swirl-image ${overlaySwirlClass}`} style={topWhiteSwirlStyle}></div> : <div className={`swirl-image ${overlaySwirlClass}`} style={topDarkSwirlStyle}></div>
      //     )
      // }else{
      //   return(
      //       (bgColor == "White") ? <div className="swirl-image" style={bottomWhiteSwirlStyle}></div> : <div className="swirl-image" style={bottomDarkSwirlStyle}></div>
      //   )          
      // }
      if(topSwirl == true){
        //top swirl
        if(bgColor == "White"){
          //white swirl
          return(
            <div className={`swirl-component`}>
              <img className={`top-swirl ${overlaySwirlClass}`} src={TopWhiteSwirl} alt="Top White Swirl"></img>
            </div>
          )
        }else{
          //dark swirl
          return(
            <div className={`swirl-component`}>
              <img className={`top-swirl ${overlaySwirlClass}`} src={TopDarkSwirl} alt="Top Dark Swirl"></img>
            </div>
          )
        }
      }else{
        //bottom swirl
        if(bgColor == "White"){
          //white swirl
          return(
            <div className="swirl-component">
              <img className="bottom-swirl" src={BottomWhiteSwirl} alt="Bottom White Swirl"></img>
            </div>
          )
        }else{
          //dark swirl
          return(
            <div className="swirl-component">
              <img className="bottom-swirl" src={BottomDarkSwirl} alt="Bottom Dark Swirl"></img>
            </div>
          )
        }
      }
      
       
}

export default SwirlComponent